module.exports = __webpack_public_path__ + "static/assets/4bd34167c17ff93ba00505bfaf1a1e92.svg";